'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertChildOrderly = insertChildOrderly;
exports.getChildMenuItemNodes = getChildMenuItemNodes;

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

function getRefIndex(nodes, ref) {
  return nodes.indexOf(ref);
}

function sortChildren(children, nodes) {
  var _children = _toArray(children),
      newChildren = _children.slice(0);

  newChildren.sort(function (childA, childB) {
    return getRefIndex(nodes, childA.ref) - getRefIndex(nodes, childB.ref);
  });
  return newChildren;
}

function insertChildOrderly(children, child, nodes) {
  var newChildren = children.concat([child]);
  var sortedChildren = sortChildren(newChildren, nodes);
  return sortedChildren;
}

function getChildMenuItemNodes(ref) {
  if (ref) {
    return ref.querySelectorAll('a[role="menuitem"]');
  }

  return [];
}